import * as angular from 'angular';

import { ComponentDefinition, Application, IApplicationConfiguration, Group } from '../../models';
import { IApplicationService, ILoggerService, ICurrentApplicationService, IchildApplicationService } from '../../services';

interface IApplicationFormCtrl extends angular.IFormController {
    applicationName: angular.INgModelController;
}

class CreateChildApplicationModalController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    currentApplication: IApplicationConfiguration;
    group: Group;
    applicationName: string;
    comment: string;
    includeChildren: boolean = true;
    formCtrl: IApplicationFormCtrl;
    modalId: string;
    applications: Application[];

    static $inject = [
        '$scope',
        '$translate',
        'applicationService',
        'currentApplicationService',
        'childApplicationService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$translate: angular.translate.ITranslateService,
        private _applicationService: IApplicationService,
        private _currentApplicationService: ICurrentApplicationService,
        private _childApplicationService: IchildApplicationService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.currentApplication = this._currentApplicationService.getApplicationConfiguration();
        this.loadApplications();
        this._$scope.$watch(() => this.group, () => this.prefillData(this.group));
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['group'] && changesObj['group'].currentValue) {
            const group: Group = changesObj['group'].currentValue;
            if (group) {
                this.prefillData(group);
            }
        }
    }

    prefillData(group: Group): void {
        if (group) {
            this.applicationName = group.name;
            this.comment = group.shortComment;
            this.validateName(this.applicationName);
        }
    }

    createFrom(): void {
        const newName = this.formCtrl.applicationName.$viewValue;
        const newApplication = {
            name: newName,
            shortComment: this.comment,
            parentApplicationGuid: this.currentApplication.guid
        } as Application;
        this._childApplicationService
            .createChildApplicationFromGroup(newApplication, this.group.guid, this.includeChildren)
            .then(result => {
                this.loadApplications(true);
                this._loggerService.logSuccess(this._$translate.instant('Child application has been created'));
            })
            .catch(result => {
                this._loggerService.logError(this._$translate.instant('Failed to create child application'));
            })
            .finally(() => {
                this.group = undefined;
                this.includeChildren = true;
                this.comment = '';
                this.formCtrl.$setPristine();
                this._$scope.$apply();
            });
    }

    validateName(applicationName: string): void {
        let isValid: boolean = true;
        const newName = applicationName.toLowerCase();
        if (!newName) {
            isValid = false;
            this.formCtrl.applicationName.$setValidity('required', isValid);
        }
        if (this.applications && this.applications.length > 0) {
            const found = this.applications.filter(a => a.name.toLowerCase() === newName);
            // Valid only if name doesn't already exist
            isValid = !(found && found.length > 0);
            this.formCtrl.applicationName.$setValidity('duplicate', isValid);
        }
    }

    private loadApplications(force: boolean = false) {
        this.isLoading = true;
        this._applicationService
            .getAll((data, status) => {
                if (status === 0) {
                    this.applications = [];
                    for (let i = 0; i < data.length; i++) {
                        const app = data[i].application;
                        this.applications.push(app);
                    }
                }
                this.isLoading = false;
            }, force);
    }
}

export const wtCreateChildApplicationModal: ComponentDefinition = {
    componentId: 'wtCreateChildApplicationModal',
    controller: CreateChildApplicationModalController,
    template: require('./createChildApplicationModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        group: '=',
        modalId: '@'
    }
};